/** Normalize API list payloads so .map / .slice never throw. */
export const asArray = (value) => (Array.isArray(value) ? value : []);

export const asStringArray = (value) =>
  asArray(value)
    .filter((v) => v != null && v !== "")
    .map(String);

export const formatCount = (n, fallback = 0) => {
  const num = Number(n);
  return (Number.isFinite(num) ? num : fallback).toLocaleString("en-IN");
};

export const formatCr = (n) => {
  const num = Number(n);
  if (!Number.isFinite(num) || num <= 0) return "₹0";
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(1)}Cr`;
  if (num >= 100000) return `₹${(num / 100000).toFixed(1)}L`;
  return `₹${num.toLocaleString("en-IN")}`;
};
